export const BUILD_VERSION = '1775762245';
